import axios from "axios";
export const baseURL = "devf.macdbs.com";

const api = axios.create({
  baseURL: "https://devf.macdbs.com",
});

export default api;
